// extracted by mini-css-extract-plugin
module.exports = {"nav-asset-v1-0-0-12":"_6dBkq3"};